import { Component, OnInit } from "@angular/core";
import { SharedService } from "../../../../../../modules/shared/services/shared.service";
import { ActivatedRoute } from "@angular/router";

@Component({
    selector: "label-config",
    templateUrl: "./label-config.view.html",
    providers: []
})
export class LabelConfigView implements OnInit {
    baseUrl = "";
    labelConfig: any = {};
    searchBarConfig: any = {};
    constructor(public sharedService: SharedService, private activatedRoute: ActivatedRoute) {
        if (this.activatedRoute.parent.routeConfig.path == "session") {
            this.baseUrl = sharedService.sessionUrl;
            this.labelConfig = this.sharedService.sessionLayoutConfig[this.baseUrl].labelConfig;
            this.searchBarConfig = this.sharedService.sessionLayoutConfig[this.baseUrl].catalogConfig;
        } else if (this.activatedRoute.parent.routeConfig.path == "speaker") {
            this.labelConfig = this.sharedService.speakerLayoutConfig.labelConfig;
        }
    }

    ngOnInit() {}
}
